import React from 'react';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import s from './PrefillDrowdown.module.sass';

const items = [
  {
    key: 'en',
    label: 'Engelska',
    onClick: () => {},
  },
  {
    key: 'sv',
    label: 'Svenska',
    onClick: () => {},
  },
];

const PrefillDropdown = ({ loadDeliveryMessage }) => {
  const handleMenuClick = ({ key }) => {
    loadDeliveryMessage(key);
  };

  return (
    <Dropdown
      menu={{
        items: items.map(item => ({
          ...item,
          onClick: () => handleMenuClick({ key: item.key }),
        })),
      }}
      trigger={['click']}
    >
      <a className={s.droplink} onClick={e => e.preventDefault()}>
        Byt språk <DownOutlined />
      </a>
    </Dropdown>
  );
};

export default PrefillDropdown;
  